module.exports = __webpack_public_path__ + "assets/img/deleteGoods.27a981fe.png";